module.exports = __webpack_public_path__ + "static/img/过期@2x.de58c97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/过期@2x.png
// module id = WOHK
// module chunks = 1